import * as React from 'react';

import './LabeledRowStyle.less';

export interface ILabeledRowProps {
  className?: string;
  label: string;
}

export default class LabeledRow extends React.PureComponent<ILabeledRowProps> {
  public render() {
    const { children, className, label } = this.props;

    return (
      <div className={`labeled-row row ${className || ''}`}>
        <div className="labeled-row-label col-md-3">{label}</div>
        <div className="col-md-9 labeled-content">{children}</div>
      </div>
    );
  }
}
